import Vue from 'vue';

const globalModule = {
  namespaced: true,
  state: {
    useToastInterceptor: true,
  },

  mutations: {
    setUseToastInterceptor(state, payload) {
      Vue.set(state, 'useToastInterceptor', payload);
    },
  },

  actions: {},
};

export default globalModule;
